// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"566":"lang/en-json","947":"lang/en-US-json"}[chunkId] + "-" + {"566":"184e6d85fd62bc609e86","947":"871dde1b3d1db8bbebc8"}[chunkId] + ".js";
};